import React from 'react'
import { Block, BlockGroup, Button, H1, H3, P } from '@mote/ui'
import { Content, DefaultLayout } from '../layouts'

export const ContactScreen = () => {
  return (
    <DefaultLayout>
      <Content>
        <div className='container'>
          <H1>Getting in touch</H1>
          <BlockGroup gap={30} margin='30px 0 30px 0'>
            <Block>
              <H3>Sales enquiries:</H3>
              <P>
                The best option is to check out our pricing page and complete
                our <a href='/quote'>quote form</a>.<br></br>
                We follow up within 1 working day.<br></br>
                Sales questions? Email us at{' '}
                <Button
                  variant='link'
                  text='success@mote.com'
                  href='mailto:success@mote.com'
                  tag='a'
                />{' '}
              </P>
            </Block>

            <Block>
              <H3>Help &amp; support:</H3>
              <p>
                Our{' '}
                <Button
                  variant='link'
                  text='support site'
                  href='https://support.mote.com/hc/'
                  tag='a'
                />{' '}
                is the fastest way to address 99% of questions.<br></br>
                Still need help? Please reach out at{' '}
                <a href='mailto:support@mote.com' className='mote-boiler-link'>
                  support@mote.com
                </a>
                .
              </p>
            </Block>
            <Block>
              <p>
                <b>Write to us:</b>
                <br></br>
                Mote Technologies, Inc.<br></br>
                548 Market St<br></br>
                PMB 52828<br></br>
                San Francisco, California 94104-5401 <br></br>
                USA<br></br>
              </p>
              <p>
                Call us*: +1 (205) 880-8969<br></br>
                <br></br>* Leave a message if no-one's home - we're usually out,
                helping make feedback awesome.
              </p>
            </Block>
          </BlockGroup>
        </div>
      </Content>
    </DefaultLayout>
  )
}
